import { createSelector } from '@reduxjs/toolkit';
import { selectHouseAreaAvailable } from 'shared/selectors/filters';
import { selectTotalArea } from 'shared/selectors/jsonQuery';

export const selectHouseAreaFilter = createSelector(
  [selectTotalArea, selectHouseAreaAvailable],
  ({ gte = null, lte = null }, visible) => ({
    label: 'Дом',
    valueMin: gte,
    valueMax: lte,
    visible,
    min: 1,
    max: 99999,
  }),
);
